import { TellescopeModelFromName, useTellescopeInfiniteQuery, useTellescopeMutation } from "@tellescope/tanstack-query";
import { DashboardCard, LoadingScreen } from "@tellescope/ui";
import { formatDateTime } from "@tellescope/utils";
import { useTranslation } from "react-i18next";

export interface FilesSectionProps {
  contact: TellescopeModelFromName<"endusers">;
}

export const FilesSection = ({ contact }: FilesSectionProps) => {
  const { t } = useTranslation("files");
  const filesQuery = useTellescopeInfiniteQuery({
    model: "files",
    method: "getSome",
    request: {
      filter: {
        enduserId: contact.id,
      },
    },
    select: (data) => data.pages.flat(),
  });

  const deleteFileMutation = useTellescopeMutation({
    model: "files",
    method: "deleteOne",
  });

  return (
    <div className="flex-1 overflow-y-auto space-y-4 pr-2">
      {filesQuery.isLoading ? (
        <LoadingScreen />
      ) : filesQuery.isError ? (
        <div className="flex h-full w-full align-middle justify-center text-muted-foreground">
          {t("Error loading files for contact.")}
        </div>
      ) : filesQuery.data?.length ? (
        filesQuery.data.map((file) => (
          <DashboardCard
            key={file.id}
            statusLabel=""
            title={file.name}
            subtitle={file.type}
            subtitleSecondary={file.size.toLocaleString()}
            assignees={null}
            description={formatDateTime(file.createdAt, "MM/DD/YYYY at hh:mm a")}
            dueDate=""
            priority=""
            timestamp={undefined}
            onDelete={() => {
              deleteFileMutation.mutate(file.id);
            }}
          />
        ))
      ) : (
        <div className="flex h-full w-full items-center justify-center text-muted-foreground">
          {t("No files for this contact.")}
        </div>
      )}
    </div>
  );
};
